var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { deleteBook, releaseBook, removeBook, setBookAvailability, } from "@/05-models/book";
import { addOrder, createOrder } from "@/05-models/order";
import { useErrorNotify } from "@/06-shared/lib/errorNotifier";
import { PopupButton, PopupWindow } from "@/06-shared/ui/popups";
import styles from "./index.module.css";
export const BookPopup = ({ book, onClose }) => {
    const showError = useErrorNotify();
    const create = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!book) {
            return;
        }
        try {
            const order = yield createOrder(book.id);
            addOrder(order);
            onClose();
        }
        catch (error) {
            showError(error);
        }
    });
    const remove = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!book) {
            return;
        }
        try {
            yield deleteBook(book.id);
            removeBook(book.id);
            onClose();
        }
        catch (error) {
            showError(error);
        }
    });
    const release = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!book) {
            return;
        }
        try {
            yield releaseBook(book.id);
            setBookAvailability(book.id, true);
            onClose();
        }
        catch (error) {
            showError(error);
        }
    });
    if (!book) {
        return null;
    }
    return (_jsxs(PopupWindow, { name: book.title, onClose: onClose, children: [_jsxs("p", { children: ["\u0410\u0432\u0442\u043E\u0440: ", book.author] }), _jsxs("p", { children: ["\u0416\u0430\u043D\u0440: ", book.genre] }), _jsxs("p", { children: ["\u0421\u0442\u0430\u0442\u0443\u0441: ", book.available ? "доступна" : "выдана"] }), _jsxs("p", { children: ["\u041F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u044B: ", book.views] }), _jsxs("div", { className: styles.description, children: [_jsx("p", { children: "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435:" }), _jsx("p", { children: book.description })] }), book.available && (_jsx(PopupButton, { name: "\u041E\u0444\u043E\u0440\u043C\u0438\u0442\u044C \u0437\u0430\u044F\u0432\u043A\u0443", onClick: create })), !book.available && (_jsx(PopupButton, { name: "\u0412\u044B\u0441\u0432\u043E\u0431\u043E\u0434\u0438\u0442\u044C \u043A\u043D\u0438\u0433\u0443", onClick: release })), _jsx(PopupButton, { name: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u043A\u043D\u0438\u0433\u0443", onClick: remove })] }));
};
